import { createContext } from 'react';

/**
 * Context for sharing userEntityId and SSR seed values with feature flag hooks.
 * The Flipt client lifecycle is managed by @flipt-io/flipt-client-react's FliptProvider.
 */
export type BucketBy = 'user' | 'device';

export interface FeatureFlagContextValue {
  /** Entity ID for flag evaluation — user hashId (로그인) or deviceEntityId (비로그인) */
  userEntityId: string;
  /** Device-level ID — stable across login/logout, used for device bucketing */
  deviceEntityId: string;
  /** Whether the feature flag provider is ready (WASM loaded, initial flags fetched) */
  isReady: boolean;
  /** Pre-evaluated boolean flag values from SSR (seed) */
  ssrFlags?: Record<string, boolean>;
  /** Pre-evaluated variant flag values from SSR (seed) */
  ssrVariants?: Record<string, string>;
}

export const FeatureFlagContext = createContext<FeatureFlagContextValue>({
  userEntityId: '',
  deviceEntityId: '',
  isReady: false,
});
